import * as React from "react";
const SvgExpandLess = (props) => /* @__PURE__ */ React.createElement("svg", { width: 10, height: 6, viewBox: "0 0 10 6", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M1 5L5 1L9 5", stroke: "#A1A1A1", strokeWidth: 1.4, strokeLinecap: "round" }));
export default SvgExpandLess;
